import { Pipe, PipeTransform } from '@angular/core';
import { getExcursionConfigurationDisplayValue } from 'ag-common-svc/lib/utils/excursions-data.utils';

@Pipe({ name: 'excursionConfigurationDisplayValue' })
export class ExcursionConfigurationDisplayValuePipe implements PipeTransform {
  transform = getExcursionConfigurationDisplayValue;
}
